import React from 'react';
import PropTypes from 'prop-types';
import Links from '../../../../../components/Link';
import { getURLwithTag } from '../../../../../routes/articleshow_v2/utils/mspUtils';
import analyticsWrapper from '../../../../../components_library/utils/analyticsWrapper';

const SummarizedStory = props => {
  const { syn, su, value, msid } = props;
  const handleClick = () => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'articleshow_extended_related_stories',
      ms_id: msid,
    });
  };
  const getTextHtml = () => {
    let text = '';
    text = (
      <>
        {su && su !== '' ? (
          <Links to={getURLwithTag(su)} onClick={() => handleClick()}>
            <strong
              dangerouslySetInnerHTML={{
                __html: value,
              }}
            />
          </Links>
        ) : (
          <strong
            dangerouslySetInnerHTML={{
              __html: value,
            }}
          />
        )}
        <br />
        <span
          dangerouslySetInnerHTML={{
            __html: syn,
          }}
        />
      </>
    );
    return text;
  };
  return <>{getTextHtml()}</>;
};

SummarizedStory.propTypes = {
  value: PropTypes.string,
  su: PropTypes.string,
  syn: PropTypes.string,
  msid: PropTypes.string,
};

SummarizedStory.defaultProps = {
  value: '',
  su: '',
  syn: '',
  msid: '',
};

export default SummarizedStory;
